import { render, staticRenderFns } from "./candidate_civil_state_gender.vue?vue&type=template&id=61399d60&scoped=true&"
import script from "./candidate_civil_state_gender.vue?vue&type=script&lang=js&"
export * from "./candidate_civil_state_gender.vue?vue&type=script&lang=js&"
import style0 from "./candidate_civil_state_gender.vue?vue&type=style&index=0&id=61399d60&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61399d60",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('61399d60')) {
      api.createRecord('61399d60', component.options)
    } else {
      api.reload('61399d60', component.options)
    }
    module.hot.accept("./candidate_civil_state_gender.vue?vue&type=template&id=61399d60&scoped=true&", function () {
      api.rerender('61399d60', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components-globalwork/metrics/candidate_civil_state_gender.vue"
export default component.exports